const colorSwatches = document.querySelectorAll(".color_swatch_img");
const colorSwatchesName = document.querySelector(".color_swatches_name");

colorSwatches.forEach(colorSwatch => {
  colorSwatch.addEventListener("mouseover", event => {
    const altText = event.target.alt;
    colorSwatchesName.innerHTML = altText;
    colorSwatchesName.style.opacity = 1;
    colorSwatchesName.style.transition = "opacity 0.5s ease-in-out";
  });

  colorSwatch.addEventListener("mouseout", event => {
    colorSwatchesName.style.opacity = 0;
    colorSwatchesName.style.transition = "opacity 0.5s ease-in-out";
  });
});
